import React from 'react';
import Base from './Base';
import { Link } from 'react-router-dom';
import { AuthFooter } from './AuthFooter';
import styles from './Login.module.css';
import { register } from 'swiper/element/bundle';
register();

export default class Login extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            mobile: '',
            password: '',
            loading: true,
            passwordFieldType: 'password'
        };
        window.document.body.classList = "nk-body bg-white npc-general pg-auth";
    }
    login(e) {
        e.preventDefault();

        if (this.isBlank(this.state.mobile)) {
            this.showErorrMessage('شماره موبایل را وارد نمایید');
            return;
        }
        if (this.isBlank(this.state.password)) {
            this.showErorrMessage('کلمه عبور را وارد نمایید');
            return;
        }
        this.httpPost("api/v1/login/do", {
            mobile: this.state.mobile,
            password: this.state.password
        })
            .then(data => {
                if (data.status === 1) {
                    window.location.href = "/";
                }
                this.showErorrMessage(data.message);
            })
            .catch(() => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    componentDidMount() {

        console.log('Component has rendered!');

        this.httpPost("api/v1/login/get")
            .then(data => {
                if (data.logged == 1) window.location.href = "/";
                else {
                    this.setState({
                        data: data,
                        loading: false
                    });
                }
            });
    }
    changePasswordFieldType() {
        if (this.state.passwordFieldType == "password") this.setState({ passwordFieldType: "text" });
        else this.setState({ passwordFieldType: "password" });
    }
    renderForm() {

        var a = (<><div className={styles['box']}>
            <div className={styles['boxContent']}>

                {/*--------------------------------- Login ---------------------------------------- */}
                <div className={styles['loginBox']}>
                    <div className="text-center">
                        <img src="/assets/images/logo.svg" alt="logo" width="100" className={styles['logo']} />
                        <h2 className={styles['gradient-text']}>صفحه ورود مشتریان رایافینتک</h2>
                    </div>
                    <form method="post" onSubmit={e => this.login(e)}>
                        <div className={styles['group-item']} >
                            <svg
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--dark-purple)" width="24" height="24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                            </svg>
                            <input tabIndex="1" defaultValue={this.state.mobile} onChange={e => this.state.mobile = e.target.value} type="text" className="" id="default-01" placeholder="شماره موبایل" />
                        </div>
                        <div className={styles['group-item']}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="var(--dark-purple)" width="24" height="24" >
                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                            </svg>

                            <input tabIndex="2" defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} type={this.state.passwordFieldType} className="" id="password" placeholder="کلمه عبور" />
                            <a onClick={() => this.changePasswordFieldType()} className="form-icon-right passcode-switch lg hand" data-target="password">
                                <em className={"passcode-icon icon-" + (this.state.passwordFieldType == "password" ? "show" : "hide") + " icon ni ni-eye"}></em>
                                <em className={"passcode-icon icon-" + (this.state.passwordFieldType == "password" ? "hide" : "show") + " icon ni ni-eye-off"}></em>
                            </a>

                        </div>
                        <button className={styles['gradient-btn']} >ورود</button>
                    </form>
                    <div className={styles['account']} >
                        <p>
                            حساب کاربری نداری؟
                            <Link to="/register/" className={styles['gradient-text']}>ساختن حساب کاربری جدید</Link>
                        </p>
                        <p>
                            <Link className="" to="/remember/">آیا رمز عبور خود را فراموش کردی؟</Link>
                        </p>
                    </div>
                    <div className={styles['namads']} >
                        <a href="/">
                            {/*<img src="/assets/images/enamad.png" alt="enamad" width="70" />*/}
                            <a referrerPolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=442218&Code=TVirUzq9Q3rn5ssi6ORY5XOoL1dPrjA7'>
                                <img referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=442218&Code=TVirUzq9Q3rn5ssi6ORY5XOoL1dPrjA7' alt='' style={{ cursor: 'pointer' }} code='TVirUzq9Q3rn5ssi6ORY5XOoL1dPrjA7' />
                            </a>
                        </a>
                    </div>
                </div>
                {/*--------------------------------- Login ---------------------------------------- */}

                {/*--------------------------------- Slider ---------------------------------------- */}

                <div className={styles['slider']} style={{ backgroundImage: 'url(/assets/images/Rectangle-608.jpg)' }}>
                    <h2 className="text-center text-white">چرا رایافینتک؟</h2>

                    <div className={styles['mainSwiper']}>
                        <div className={styles['swiper-wrapper']}>

                            <swiper-container slides-per-view="1" speed="500" loop="true" pagination="true" autoplay="false">
                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider2.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>1</span>
                                            <p>عدم نیاز به زیرساخت شبکه و سیستم قوی</p>
                                        </div>
                                    </div>
                                </swiper-slide>

                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider3.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>2</span>
                                            <p>بدون قفل سخت افزاری</p>
                                        </div>
                                    </div>
                                </swiper-slide>

                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider4.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>3</span>
                                            <p>بدون نیاز به آپدیت نرم افزار و هزینه پشتیبانی</p>
                                        </div>
                                    </div>
                                </swiper-slide>

                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider5.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>4</span>
                                            <p>امکان استفاده از حسابدار دورکار</p>
                                        </div>
                                    </div>
                                </swiper-slide>

                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider6.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>5</span>
                                            <p>مشاوره مالیاتی و عملیات حسابداری آنلاین از طریق نرم افزار</p>
                                        </div>
                                    </div>
                                </swiper-slide>

                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider7.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>6</span>
                                            <p>کاهش هزینه کسب و کار</p>
                                        </div>
                                    </div>
                                </swiper-slide>

                                <swiper-slide>
                                    <div>
                                        <img src="/assets/images/slider/slider1.png" alt="image" width="300" />
                                        <div className={styles['slide-content']}>
                                            <span>7</span>
                                            <p>امنیت بالا و بکاپ گیری منظم اتومات</p>
                                        </div>
                                    </div>
                                </swiper-slide>
                                ...
                            </swiper-container>


                        </div>

                    </div>
                    <div className="clients">
                        <div className={styles['separator']} ><p>مشتریان ما</p></div>
                        <div className={styles['swiperBrands']}>

                            <div>
                                <swiper-container slides-per-view="4" space-between="1" speed="500" loop="true" autoplay="true">

                                    <swiper-slide>
                                        <div>
                                            <img src="/assets/images/Partners/logo_1.svg" />

                                        </div>
                                    </swiper-slide>

                                    <swiper-slide>
                                        <div>
                                            <img src="/assets/images/Partners/logo_2.svg" />
                                        </div>
                                    </swiper-slide>

                                    <swiper-slide>
                                        <div>
                                            <img src="/assets/images/Partners/logo_3.svg" />
                                        </div>
                                    </swiper-slide>

                                    <swiper-slide>
                                        <div>
                                            <img src="/assets/images/Partners/logo_4.svg" />
                                        </div>
                                    </swiper-slide>

                                    <swiper-slide>
                                        <div>
                                            <img src="/assets/images/Partners/logo_5.svg" />
                                        </div>
                                    </swiper-slide>

                                </swiper-container>
                            </div>

                        </div>
                    </div>
                </div>
                {/*--------------------------------- Slider ---------------------------------------- */}

            </div>
        </div>
            <AuthFooter Data={this.state.data} />
        </>
        );

        var b = (<div className="nk-content ">
            <div className="nk-block nk-block-middle nk-auth-body  wide-xs">
                <div className="brand-logo pb-4 text-center">
                    <Link to="/" className="logo-link">
                        <img className="logo-light logo-img logo-img-lg" src="/assets/images/logo.webp" alt="" />
                        <img className="logo-dark logo-img logo-img-lg" src="/assets/images/logo-dark.webp" alt="" />
                    </Link>
                </div>
                <div className="card card-bordered">
                    <div className="card-inner card-inner-lg">
                        <div className="nk-block-head">
                            <div className="nk-block-head-content">
                                <h4 className="nk-block-title">ورود به سیستم</h4>
                            </div>
                        </div>
                        <form method="post" onSubmit={e => this.login(e)}>
                            <div className="form-group">
                                <div className="form-label-group">
                                    <label className="form-label" htmlFor="default-01">شماره موبایل</label>
                                </div>
                                <div className="form-control-wrap">
                                    <input tabIndex="1" defaultValue={this.state.mobile} onChange={e => this.state.mobile = e.target.value} type="text" className="form-control form-control-lg" id="default-01" placeholder="شماره موبایل" />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="form-label-group">
                                    <label className="form-label" htmlFor="password">کلمه عبور</label>
                                    <Link className="link link-primary link-sm" to="/remember/">بازیابی کلمه عبور</Link>
                                </div>
                                <div className="form-control-wrap">
                                    <a onClick={() => this.changePasswordFieldType()} className="form-icon form-icon-right passcode-switch lg hand" data-target="password">
                                        <em className={"passcode-icon icon-" + (this.state.passwordFieldType == "password" ? "show" : "hide") + " icon ni ni-eye"}></em>
                                        <em className={"passcode-icon icon-" + (this.state.passwordFieldType == "password" ? "hide" : "show") + " icon ni ni-eye-off"}></em>
                                    </a>
                                    <input tabIndex="2" defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} type={this.state.passwordFieldType} className="form-control form-control-lg" id="password" placeholder="کلمه عبور" />
                                </div>
                            </div>
                            <div className="form-group">
                                <button className="btn btn-lg btn-primary btn-block">ورود</button>
                            </div>
                        </form>
                        <div className="form-note-s2 text-center pt-4"> حساب کاربری ندارید؟ <Link to="/register/">عضویت و ایجاد حساب</Link></div>
                    </div>
                </div>
            </div>
            <AuthFooter Data={this.state.data} />
        </div>)


        return a;

    }
    render() {
        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {contents}
            </div>
        );
    }
}